export default "/images/18e73ff2ee8f1dd2b98486e78ac83af5.jpg";